const isValidParam = (step) => {
  const steps = ["detalles", "extras", "datos", "confirmacion"];
  return steps.indexOf(step);
}

export default isValidParam;

